<div class="modal-content" [style.width]="width">
  <div class="modal-content__head">
    <p class="modal-content__head-title">{{ modalTitle | limitText:modalTitleChartsLimit }}</p>
    <button class="modal-content__head-close" (click)="closeModal.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content__body">
    <ng-content></ng-content>
  </div>

  <div class="modal-content__btns">
    <button
      class="modal-content__btns-success"
      mat-raised-button
      color="primary"
      (click)="successModal.emit()"
      [disabled]="(busyService.busyState$ | async).isBusy"
      *ngIf="!hiddenButtons.includes('success')"
    >
      {{ successBtnContent }}
    </button>
    <button
      class="modal-content__btns-close"
      mat-raised-button
      *ngIf="!hiddenButtons.includes('close')"
      (click)="closeModal.emit()"
    >
      {{ stringsService.strings.cancel }}
    </button>
  </div>
</div>
